export default "__VITE_ASSET__DbkaAfQE__"